import React, { useState } from 'react';
import { MemberState } from '../../../../../types/zinantis/members/membersType';
import Card from '../../../../../muiComponents/Card';
import Image from '../../../../components/Image';
import Tooltip from '../../../../../muiComponents/Tooltip';
import Flag from '../../../components/Flag';
import MemberPanel from '../MemberPanel';
import DotIcon from '../../../../components/DotIcon';

interface MemberCardProps {
    member: MemberState;
}
const MembersCard = (props: MemberCardProps) => {
    const { member } = props;
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);

    return (
        <>
            <Card
                className='member-card__container'
                onClick={() => setIsPopUpOpen(true)}
            >
                <div className='member-card__logo-container'>
                    {member.logo ? (
                        <Image
                            className='member-card__image'
                            src={member.logo}
                        />
                    ) : (
                        <div className='member-card__logo-name'>
                            <p>{member.name}</p>
                        </div>
                    )}
                </div>
                <div className='member-card__title'>
                    <div className='flex flex-align-center gap-5 flex-between'>
                        <h5>{member.name}</h5>
                        <Tooltip
                            titleText={
                                member?.connected ? 'connected' : 'disconnected'
                            }
                        >
                            <span>
                                <DotIcon
                                    truthy={member?.connected}
                                    falsy={!member?.connected}
                                />
                            </span>
                        </Tooltip>
                    </div>
                    <div className='flex gap-5 flex-align-center'>
                        {member.countryCode && (
                            <Flag
                                text={member.country}
                                code={member.countryCode}
                            />
                        )}

                        <p>{member.country}</p>
                    </div>
                </div>
            </Card>
            {isPopUpOpen && (
                <MemberPanel
                    open={isPopUpOpen}
                    onClose={() => setIsPopUpOpen(false)}
                    memberId={member.id}
                    isConnected={!!member.connected}
                    memberHotels={member.hotels}
                />
            )}
        </>
    );
};

export default MembersCard;
